import apiClient from './config'

var CARTOON_VIDEO_STYLE_CONVERTER_PATH = '/cartoonVideoStyleConverter'
var ANIME_VIDEO_STYLE_CONVERTER_PATH = '/animeVideoStyleConverter'
var OIL_PAINTING_VIDEO_STYLE_CONVERTER_PATH = '/oilPaintingVideoStyleConverter'
var CYBERPUNK_VIDEO_STYLE_CONVERTER_PATH = '/cyberpunkVideoStyleConverter'
var QUERY_CAPYBARA_VIDEO_RESULT_PATH = '/queryCapybaraVideoResult'
var POLL_INTERVAL = 10000
var POLL_TIMEOUT = 10 * 60 * 1000

function normalizeResultUrl(url) {
  var s = String(url || '').trim()
  if (!s) return ''
  if (/^https?:\/\//i.test(s) || s.indexOf('data:') === 0) return s
  if (s.charAt(0) !== '/') return s
  var base = apiClient.defaults && apiClient.defaults.baseURL ? String(apiClient.defaults.baseURL) : ''
  if (!base || base.charAt(0) === '/') return s
  try {
    var u = new URL(base)
    return u.origin + s
  } catch (e) {
    return s
  }
}

function parsePromptId(payload) {
  var data = payload && payload.data ? payload.data : payload
  var promptId = data && (data.prompt_id || data.promptId)
  return promptId ? String(promptId) : ''
}

function submitVideoStyleConverter(path, videoUrl, label) {
  var url = String(videoUrl || '').trim()
  if (!url) return Promise.reject(new Error('videoUrl is required'))
  return apiClient.post(path, { videoUrl: url }).then(function (payload) {
    var promptId = parsePromptId(payload)
    if (!promptId) return Promise.reject(new Error(label + ' did not return prompt_id'))
    var data = payload && payload.data ? payload.data : {}
    return {
      promptId: promptId,
      seed: data.seed,
      width: data.width,
      height: data.height,
      length: data.length
    }
  })
}

export function submitCartoonVideoStyleConverter(videoUrl) {
  return submitVideoStyleConverter(CARTOON_VIDEO_STYLE_CONVERTER_PATH, videoUrl, 'cartoonVideoStyleConverter')
}

export function submitAnimeVideoStyleConverter(videoUrl) {
  return submitVideoStyleConverter(ANIME_VIDEO_STYLE_CONVERTER_PATH, videoUrl, 'animeVideoStyleConverter')
}

export function submitOilPaintingVideoStyleConverter(videoUrl) {
  return submitVideoStyleConverter(OIL_PAINTING_VIDEO_STYLE_CONVERTER_PATH, videoUrl, 'oilPaintingVideoStyleConverter')
}

export function submitCyberpunkVideoStyleConverter(videoUrl) {
  return submitVideoStyleConverter(CYBERPUNK_VIDEO_STYLE_CONVERTER_PATH, videoUrl, 'cyberpunkVideoStyleConverter')
}

export function queryCapybaraVideoResult(promptId) {
  var id = String(promptId || '').trim()
  if (!id) return Promise.reject(new Error('promptId is required'))
  return apiClient.post(QUERY_CAPYBARA_VIDEO_RESULT_PATH, null, {
    params: { promptId: id },
    allowBizCodes: [202]
  }).then(function (payload) {
    var code = Number(payload && payload.code)
    if (code === 202) {
      return { status: 'processing', promptId: id }
    }
    var data = payload && payload.data ? payload.data : {}
    var resultUrl = data.oss_video_url || data.video_url || ''
    resultUrl = normalizeResultUrl(resultUrl)
    if (!resultUrl) return Promise.reject(new Error('No result video was returned'))
    return {
      status: 'completed',
      promptId: data.prompt_id || id,
      url: resultUrl,
      localPath: data.video_local_path || '',
      seed: data.seed,
      width: data.width,
      height: data.height,
      length: data.length,
      fps: data.fps
    }
  })
}

export function pollCapybaraVideoResult(promptId, callback, interval) {
  var pollInterval = interval || POLL_INTERVAL
  var deadline = Date.now() + POLL_TIMEOUT
  var timer = null
  var stopped = false

  function stop() {
    stopped = true
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
  }

  function scheduleNext() {
    if (stopped) return
    if (Date.now() > deadline) {
      if (typeof callback === 'function') callback(new Error('Polling timeout'), null)
      stop()
      return
    }
    timer = setTimeout(poll, pollInterval)
  }

  function poll() {
    if (stopped) return
    queryCapybaraVideoResult(promptId).then(function (res) {
      if (stopped) return
      if (res.status === 'processing') {
        if (typeof callback === 'function') callback(null, res)
        scheduleNext()
        return
      }
      if (typeof callback === 'function') callback(null, res)
      stop()
    }).catch(function (err) {
      if (typeof callback === 'function') callback(err, null)
      stop()
    })
  }

  poll()
  return { stop: stop }
}

export default {
  submitCartoonVideoStyleConverter: submitCartoonVideoStyleConverter,
  submitAnimeVideoStyleConverter: submitAnimeVideoStyleConverter,
  submitOilPaintingVideoStyleConverter: submitOilPaintingVideoStyleConverter,
  submitCyberpunkVideoStyleConverter: submitCyberpunkVideoStyleConverter,
  queryCapybaraVideoResult: queryCapybaraVideoResult,
  pollCapybaraVideoResult: pollCapybaraVideoResult
}
